import { render, staticRenderFns } from "./HomeOverview.vue?vue&type=template&id=ba8aff66&scoped=true&"
import script from "./HomeOverview.vue?vue&type=script&lang=js&"
export * from "./HomeOverview.vue?vue&type=script&lang=js&"
import style0 from "./HomeOverview.vue?vue&type=style&index=0&id=ba8aff66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8aff66",
  null
  
)

export default component.exports